import { Icon } from "antd";
import * as React from "react";
import {
  Home,
  User,
  Jinjian,
  PostLoan,
  Property,
  Operation,
  Clearing,
  Blocks,
} from "../containers";
import Edi from '../containers/Jinjian/Order';
import Muyuan from '../containers/Jinjian/Payable';
import BlockChain from '../containers/Blocks/BlockChain';
import Kssl from '../containers/Blocks/Kssl';
import Token from '../containers/Blocks/Token';

export const allType = [
  {
    name: "首页",
    value: "home",
  },
  {
    name: "数据验证",
    value: "verification",
  },
  {
    name: "数据概览",
    value: "dataOverview",
  },
  {
    name: "订单查询",
    value: "orderData",
  },
  {
    name: "数据分析",
    value: "dataAnalysis",
  },
  {
    name: "风险预警",
    value: "warning",
  },
  {
    name: "重复转让查验",
    value: "inspection",
  },
  {
    name: "权限管理",
    value: "management",
  },
  {
    name: "日志查询",
    value: "journal",
  },
];

type MenuContent = {
  id: string;
  title: string;
  MenuIcon?: JSX.Element;
  MenuContent?: Array<MenuContent>;
};

const home: MenuContent = {
  id: "home",
  title: "首页",
  MenuIcon: <Icon type="dashboard" />,
};

const jinjian: MenuContent = {
  id: "jinjian",
  title: "进件管理",
  MenuIcon: <Icon type="database" />,
  MenuContent: [
    {
      id: "edi",
      title: "订单贷",
    },
    {
      id: "muyuan",
      title: "应付账款",
    },
  ],
};

const property: MenuContent = {
  id: "property",
  title: "资产管理",
  MenuIcon: <Icon type="cluster" />,
};

const operation: MenuContent = {
  id: "operation",
  title: "运营中心",
  MenuIcon: <Icon type="cloud-sync" />,
};

const clearing: MenuContent = {
  id: "clearing",
  title: "清分系统",
  MenuIcon: <Icon type="control" />,
};

const postLoan: MenuContent = {
  id: "postLoan",
  title: "贷后管理",
  MenuIcon: <Icon type="inbox" />,
};

const user: MenuContent = {
  id: "user",
  title: "用户模块",
  MenuIcon: <Icon type="user" />,
  MenuContent: [
    {
      id: "management",
      title: "权限管理",
    },
    {
      id: "journal",
      title: "日志查询",
    },
  ],
};

const blockChain: MenuContent = {
  id: "block",
  title: "区块链",
  MenuIcon: <Icon type="compass" />,
  MenuContent: [
    {
      id: "blockChain",
      title: "区块浏览器",
    },
    {
      id: "kssl",
      title: "快速上链",
    },
    {
      id: "ljf",
      title: "区块链通证",
    },
  ],
};

export const allMenuItems = [
  home,
  jinjian,
  postLoan,
  operation,
  clearing,
  property,
  blockChain,
  //  chaipiao, daikuan, daihou, user
];

export const JurisdictionMenu = () => {
  // let store_user = localStorage.getItem("user");
  // if (store_user) {
  //   let user = JSON.parse(store_user);
  //   let perms = user.perms;
  //   if (!perms || perms.length === 0) {
  //     // return [
  //     //   home
  //     // ]
  //     return [];
  //   } else {
  //     let Menus = allMenuItems.map((item) => {
  //       // 不存在二级菜单时
  //       if (!item.MenuContent && perms.includes(item.id)) {
  //         return item;
  //       } else if (item.MenuContent) {
  //         let newMenuContent = item.MenuContent.filter((item2, index) => {
  //           return perms.includes(item2.id);
  //         });
  //         if (newMenuContent.length === 0) {
  //           return null;
  //         } else {
  //           let menus = {
  //             title: item.title,
  //             id: item.id,
  //             MenuIcon: item.MenuIcon,
  //             MenuContent: newMenuContent,
  //           };
  //           return menus;
  //         }
  //       }
  //     });
  //     // 所有添加首页
  //     // Menus.unshift(home)
  //     return Menus.filter((item) => item);
  //     // return allMenuItems
  //   }
  // } else {
  //   return allMenuItems;
  // }
  return allMenuItems;
};

export const JurisdictionCount = () => {
  return [
    {
      id: "home",
      dom: Home,
    },
    {
      id: "user",
      dom: User,
    },
    // {
    //   id: "jinjian",
    //   dom: Jinjian,
    // },
    {
      id: "edi",
      dom: Edi,
    },
    {
      id: "muyuan",
      dom: Muyuan,
    },
    {
      id: "property",
      dom: Property,
    },
    {
      id: "postLoan",
      dom: PostLoan,
    },
    {
      id: "clearing",
      dom: Clearing,
    },
    {
      id: "blockChain",
      dom: BlockChain,
    },
    {
      id: "kssl",
      dom: Kssl,
    },
    {
      id: "ljf",
      dom: Token,
    },
    {
      id: "operation",
      dom: Operation,
    },
  ];
};

export default {
  JurisdictionMenu,
  JurisdictionCount,
  allMenuItems,
  allType,
};
